export default __webpack_public_path__ + "static/media/anhcuoi.96f1ee1a.jpg";